import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { useRegisteredTheme } from './theme-registry';

interface IWATThemeProviderProps {
    themeName?: string;
    children?: React.ReactElement<any>;
}

export const WatReactUxThemeProvider = React.memo((props: IWATThemeProviderProps) => {
    const { themeName = 'default' } = props;
    const theme = useRegisteredTheme(themeName);

    return (
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    );
});

WatReactUxThemeProvider.displayName = 'WatReactUxThemeProvider';
